import { grey } from "@mui/material/colors";

const styles = {
  container: {
    position: "relative",
    height: "100%",
    overflowY: "auto",
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
  },
  header: {
    p: 1,
    borderBottom: `1px solid ${grey[200]}`,
  },
  body: {
    pb: 4,
    overflowY: "auto",
    height: {
      xs: "auto",
      md: "calc(100vh - 240px)",
      lg: "calc(100vh - 200px)",
    },
  },
  footer: {
    py: 1,
  },
  buttonTab: {
    textTransform: "none",
    color: grey[700],
    fontSize: 12,
    mb: -1,
    borderRadius: 0,
  },
  active: {
    borderBottom: `2px solid`,
    borderColor: "primary.main",
    color: "primary.main",
  },
  cancelAllButton: {
    color: "error.main",
    fontSize: 12,
    textTransform: "none",
  },
};

export default styles;
